/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = RepairOrderQuote
 *
 * 1 = CheckIn
 *
 * 2 = CheckOut
 */
export enum EmailDeliveryOptionEnum {
  RepairOrderQuote = 0,
  CheckIn = 1,
  CheckOut = 2,
}
